export default __webpack_public_path__ + "static/fondo-material-4ac9c3e4364a57aa04b9721a7b2f2762.png";